import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import * as Yup from "yup";
import {withFormik} from "formik";
import moment from "moment";
import getPhoneValues from "@gqlapp/base/utils/getPhoneValues";

const registerProps = withProps(
  ( { handleSubmit, submitting, setFieldValue, values }: any)=>{
    return ({ props: { handleSubmit, submitting, setFieldValue, level: values?.level }})
  });


function callback(func: any){
  return (value: any)=>{
    let phone = getPhoneValues(value)
    let phoneNumber = `${phone?.phoneNumber}`.replace(/\D/g, "");
    Object.assign(phone, { phoneNumber });
    return func(phone);
  }
}

const composeWithFormik = withFormik({
  mapPropsToValues: ({ values }: any) => values,
  handleSubmit: async (values, { props:{ setRegisterValues, signInWithPhoneNumber } }) => {
    let phoneNumber = values?.phone;
    phoneNumber = phoneNumber.replace(/\D/g, '');
    phoneNumber = phoneNumber.replace('+', '');
    signInWithPhoneNumber(`+${phoneNumber}`)
      .then(() => setRegisterValues(values, 2))
      .catch(errorCatch);
  },
  validationSchema: ({ userCount }) =>
    Yup.object().shape({

      birthday:  Yup.mixed()
        .when('level', {
          is: (l: number) => (l > 0),
          then: (s)=>
            s.when('birthday',{
              is:(b: any)=> (b?.day || b?.month || b?.year ),
              then: (s)=> s
                .test('birthday', 'Hãy nhập ngày sinh.'.t(), function (birthday){
                  return !!birthday?.day;
                })
                .test('birthday', 'Ngày sinh phải nhỏ hơn hoặc bằng {{value}}.'.t({ value: 31 }), function (birthday){
                  return birthday?.day <= 31;
                })
                .test('birthday', 'Hãy nhập tháng sinh.'.t(), function (birthday){
                  return !!birthday?.month;
                })
                .test('birthday', 'Ngày sinh phải nhỏ hơn hoặc bằng {{value}}.'.t({ value: 12 }), function (birthday){
                  return birthday?.month <= 12;
                })
                .test('birthday', 'Hãy nhập năm sinh.'.t(), function (birthday){
                  return !!birthday?.year;
                })
                .test('birthday', 'Năm sinh phải lớn hơn hoặc bằng {{value}} tuổi.'.t({ value: 18 }), function (birthday){
                  let now       = Number(moment().format('YYYY'))
                  let year          = Number(birthday?.year);
                  let yearOld   = now - year;
                  return yearOld >= 18;
                })
            })

        }),

      phone:  Yup.mixed()
        .when('level', {
          is: (l: number) => (l > 0),
          then: (s)=>s
            .test('phone', 'Hãy nhập số điện thoại.'.t(),
              callback(({ phoneNumber })=> !!phoneNumber ))
            .test('phone', 'Số điện thoại phải có ít nhất 9 ký tự.'.t(),
              callback(({ phoneNumber })=> phoneNumber.length >= 9 ))
            .test('phone', 'Số điện thoại quá dài.'.t(),
              callback(({ phoneNumber })=> phoneNumber.length < 13 ))
            .when('phone',{
              is: callback(({ phoneNumber })=>{
                let len = phoneNumber.length;
                return len >=9 && len <= 13
              }),
              then: s => s
                .test('phone', 'Số điện thoại đã tồn tại.'.t(),
                  callback(async ({ code, phoneNumber })=> {
                    phoneNumber = parseInt(phoneNumber);
                    const { count } = await userCount({ filter: { search: [{ keyword: `${code} ${phoneNumber}`, type: 'phone' }]}})
                    return !count;
                  } ))
            })

        })

    }),
  enableReinitialize: true,
  displayName: 'RegisterForm', // helps with React DevTools
});

export default compose(composeWithFormik, registerProps);
